import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Checkbox, TableRow, TableCell, MenuItem, Avatar, Typography } from '@mui/material';
import { Switch } from '@mui/material';

import Iconify from '../../../../../shared/components/Iconify';
import { TableMoreMenu } from '../../../../../shared/components/table';
import { EstateObject } from '../../../../../shared/@types/blog';
import Image from '../../../../../shared/components/Image';

type Props = {
  row: EstateObject;
  selected: boolean;
  onEditRow: VoidFunction;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  onPublish: (isPublished: boolean) => void;
};

export default function RealEstateTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  onPublish,
}: Props) {
  const { realtor, id, title, images, isPublished, createdAt, price } = row;

  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover selected={selected}>
      <TableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </TableCell>

      <TableCell align="left">
        <Image
          disabledEffect
          visibleByDefault
          alt="empty content"
          src={images[0] || '/assets/illustrations/illustration_empty_content.svg'}
          sx={{ height: 40, width: 40 }}
        />
      </TableCell>
      <TableCell align="left">{id}</TableCell>
      <TableCell align="left">{title}</TableCell>
      <TableCell align="left">
        <Switch
          checked={isPublished}
          onChange={() => {
            onPublish(!isPublished);
          }}
        />
      </TableCell>

      <TableCell align="left">{price}</TableCell>
      <TableCell align="left">{createdAt}</TableCell>

      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar alt={realtor?.username} src={realtor?.avatarUrl} sx={{ mr: 2 }} />
        <Typography variant="subtitle2" noWrap>
          {realtor?.username}
        </Typography>
      </TableCell>

      <TableCell align="right">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <>
              <MenuItem
                onClick={() => {
                  onDeleteRow();
                  handleCloseMenu();
                }}
                sx={{ color: 'error.main' }}
              >
                <Iconify icon={'eva:trash-2-outline'} />
                Delete
              </MenuItem>
              <MenuItem
                onClick={() => {
                  onEditRow();
                  handleCloseMenu();
                }}
              >
                <Iconify icon={'eva:edit-fill'} />
                Edit
              </MenuItem>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
